import { http } from '@/services/api/client';
import type {
  NotificationListItem,
  NotificationPageResult,
  QueryNotificationsParams,
  UnreadCountResult,
} from '@/types/notification';

export async function fetchNotifications(
  params: QueryNotificationsParams,
): Promise<NotificationPageResult> {
  return http.get('/notifications', { params }) as Promise<NotificationPageResult>;
}

export async function fetchUnreadCount(): Promise<UnreadCountResult> {
  return http.get('/notifications/unread-count') as Promise<UnreadCountResult>;
}

export async function fetchNotification(receiverId: string): Promise<NotificationListItem> {
  return http.get(`/notifications/${receiverId}`) as Promise<NotificationListItem>;
}

export async function markNotificationRead(receiverId: string): Promise<NotificationListItem> {
  return http.post(`/notifications/${receiverId}/read`) as Promise<NotificationListItem>;
}

export async function markAllNotificationsRead(payload?: {
  type?: QueryNotificationsParams['type'];
}): Promise<{ updated: number }> {
  return http.post('/notifications/read-all', payload ?? {}) as Promise<{ updated: number }>;
}

export async function deleteNotification(receiverId: string): Promise<{ success: true }> {
  return http.delete(`/notifications/${receiverId}`) as Promise<{ success: true }>;
}
